import React from "react";
import { FC } from "react";
import { Trans } from "@helpers/translate";
import Icon from "../Icon";

interface Props {
  slot: number;
  month: string;
}

export const Scarcity: FC<Props> = ({ slot, month }) => {
  if (slot > 15) {
    return <div></div>;
  }

  return (
    <div className="my-2 flex text-primary text-sm justify-center items-center  font-semibold">
      <Icon icon="announce" className="text-primary mr-1" size="sm" />

      {slot === 0 && (
        <Trans id="scarcity.message.no-slot">
          {month}: No slots available!
        </Trans>
      )}

      {slot === 1 && (
        <Trans id="scarcity.message.slot">{month}: Only 1 slot left!</Trans>
      )}

      {slot > 1 && (
        <Trans id="scarcity.message.slots">
          {month}: Only {slot} slots left!
        </Trans>
      )}
    </div>
  );
};
